import React from 'react'
import PropTypes from 'prop-types'
import {Link} from 'react-router-dom'
import ArrowLeftYellow from '#components/svg/icons/ArrowLeftYellow'

export function LinkWithArrow(props) {
  return (
    <div className="linkwitharrow">
      <Link className="link" to={props.to}>
        {props.text}
      </Link>
      <ArrowLeftYellow />
    </div>
  )
}

LinkWithArrow.propTypes = {
  text: PropTypes.string,
  to: PropTypes.string,
}
